import React, {useEffect} from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {makeStyles, createStyles} from '@mui/styles';
import {useSelector} from 'react-redux';
import {selectMe} from './../../features/stores/user.slice';

const useStyles = makeStyles(() =>
  createStyles({
    backdrop: {
      zIndex: 10,
      color: '#fff',
    },
  }),
);

const BackDropLoader = () => {
  const classes = useStyles();
  const user: any = useSelector(selectMe);
  const [open, setOpen] = React.useState(true);

  useEffect(() => {
    if (user?.loginStatus == 'LOGGED_IN') {
        setOpen(false);
    }
  }, [user?.loginStatus]);

  return (
    <div>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default BackDropLoader;
